module.exports = __webpack_public_path__ + "static/media/inventor.ec62705f.png";